import { Separator } from '../../../../../primitives/separator';
import { EditorPlain } from '../../../../editor/components/editor-plain';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { ImageUrl } from '../controls/image-url';
import { Spacing } from '../controls/spacing';
import { Appearance } from './appearance';

import type { ImageEditorContentProps } from './types';

export type { ImageEditorStyleUpdates } from './types';

export function ImageEditorContent({
  altText,
  backgroundColor,
  borderRadius,
  clickThroughUrl,
  height,
  horizontalAlignment,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  mediaPicker,
  sourceUrl,
  verticalAlignment,
  width,
  onAltTextChange,
  onClickThroughUrlChange,
  onHeightChange,
  onSourceUrlChange,
  onStyleChange,
  onWidthChange,
}: ImageEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div className="grid gap-y-1">
          <ImageUrl
            id="content-image-source-url"
            value={sourceUrl}
            mediaPicker={mediaPicker}
            onChange={onSourceUrlChange}
          />
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Texto descriptivo de imagen
            </LabelWithoutRef>
            <EditorPlain
              counter={{ enable: true }}
              id="content-image-alt-text"
              type="input"
              value={altText}
              onChange={(value) => onAltTextChange(value)}
            />
          </div>
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              URL de destino
            </LabelWithoutRef>
            <EditorPlain
              id="content-image-click-through-url"
              type="input"
              value={clickThroughUrl}
              onChange={(value) => onClickThroughUrlChange(value)}
            />
          </div>
        </div>
      </div>

      <Separator />

      <Appearance
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
        height={height}
        width={width}
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
        onBorderRadiusChange={(borderRadius) => onStyleChange({ borderRadius })}
        onHeightChange={onHeightChange}
        onWidthChange={onWidthChange}
      />

      <Separator />

      <Alignment
        horizontalAlignment={horizontalAlignment}
        isHorizontalAlignmentVisible
        isVerticalAlignmentVisible
        verticalAlignment={verticalAlignment}
        onHorizontalAlignmentChange={(newAlignment) => onStyleChange({ textAlign: newAlignment })}
        onVerticalAlignmentChange={(newAlignment) =>
          onStyleChange({ verticalAlignment: newAlignment })
        }
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
